export default {
    dashboardsCallStats: {
        datePicker: 'call-stats/input/1',
        searchButton: 'call-stats/button/1',
        groupingSelect: 'call-stats/select/1',
        metricsSelect: 'call-stats/select/2',
        callStatsChart: 'call-stats/canvas/1',
    },
};
